@if (isloaded) {
  <div>
    <ebb-training  [trainingType]="trainingType" [currentUser]="currentUser"></ebb-training>
  </div>
}
